import { message } from "antd";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import api from "../../hooks/api";
import { pathAPI } from "../../utils/pathApi";
import ManageTranslationModal, { ManageTranslationItem } from "./ManageTranslationModal";

interface TranslationModalProps {
  open: boolean;
  onCancel: () => void;
  onSuccess?: () => void;
  entityId: string | number;
  entityType: 'category' | 'salon' | 'package' | 'system';
  translations: ManageTranslationItem[];
  languages: Array<{
    id: number;
    language_code: string;
    name: string;
  }>;
  title?: string;
  entityName?: string;
}

interface AutoTranslateResponse {
  data?: {
    translations?: Record<string, string>;
  };
}

const TranslationModal: React.FC<TranslationModalProps> = ({
  open,
  onCancel,
  onSuccess,
  entityId,
  entityType,
  translations,
  languages,
  title,
  entityName,
}) => {
  const { t } = useTranslation();
  const getApiEndpoint = () => {
    switch (entityType) {
      case 'category':
        return `${pathAPI.categoryDetail}/${entityId}/translations`;
      case 'salon':
        // return `${pathAPI.salonDetail}/${entityId}/translations`;
      case 'package':
        // return `${pathAPI.packageDetail}/${entityId}/translations`;
      case 'system':
        // return `${pathAPI.systemConfig}/${entityId}/translations`;
      default:
        return "";
    }
  };

  const handleSave = async (items: ManageTranslationItem[]) => {
    const payload = items.map((item) => ({
      translation_id: item.translation_id,
      translation_name: item.translation_name,
      language_id: item.language_id,
      language_code: item.language_code,
    }));

    try {
      await api.PUT(getApiEndpoint(), payload, {}, true);
    } catch (error) {
      console.error("Error updating translations:", error);
      message.error(t("common.translation_modal.update_failed"));
      throw error;
    }
    message.success(t("common.translation_modal.update_success"));
    onSuccess?.();
  };

  const handleAutoTranslate = useCallback(async (text: string, sourceLanguageCode: string) => {
    const response = await api.POST<AutoTranslateResponse>(
      `${pathAPI.categoryDetail}/translations/auto`,
      { text, source_language_code: sourceLanguageCode },
      {},
      true
    );
    return response?.data?.translations || {};
  }, []);

  return (
    <ManageTranslationModal
      open={open}
      title={title ?? t("common.translation_modal.title")}
      subtitle={entityName}
      languages={languages}
      translations={translations}
      requireAll
      onCancel={onCancel}
      onSave={handleSave}
      onAutoTranslate={entityType === 'category' ? handleAutoTranslate : undefined}
    />
  );
};

export default TranslationModal;
